export default __webpack_public_path__ + "static/media/EDO carrousel.c7cada66.zip";